const _excluded = ["user", "currentProductId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { track } from '@adsk/acs-web-analytics';
import { stylePropType } from '@adsk/alloy-react-theme';
import { EVENTS } from './helpers/const';
import { userPropType } from './helpers/types';
import { getTrackingProperties } from './helpers/utils';
import { useUserSubscriptions, useTrialMessage } from './hooks';
import TrialBannerView from './TrialBannerView';
/**
 * A TrialBanner
 * Trial banner allow to show messages and options to manage the subscriptions of the user.
 */

const TrialBanner = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      user,
      currentProductId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    userTrialSubscriptions,
    showBanner
  } = useUserSubscriptions();
  const trialMessage = useTrialMessage({
    userTrialSubscriptions
  });
  const trackOpenModal = useCallback(() => {
    if (!user || !userTrialSubscriptions) return null;
    return track(EVENTS.OPEN, _objectSpread({}, getTrackingProperties(user, userTrialSubscriptions, currentProductId ? currentProductId : 'projects')));
  }, [currentProductId, user, userTrialSubscriptions]);
  return userTrialSubscriptions ? /*#__PURE__*/React.createElement(TrialBannerView, _extends({}, props, {
    ref: ref,
    message: showBanner ? trialMessage : null,
    userTrials: userTrialSubscriptions,
    displayButton: showBanner,
    onClickAnalytics: trackOpenModal
  })) : null;
});
TrialBanner.displayName = 'TrialBanner';
TrialBanner.defaultProps = {
  user: null
};
TrialBanner.propTypes = {
  /** Current Product Id */
  currentProductId: PropTypes.string,
  /** Current User */
  user: userPropType,
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string
};
export default TrialBanner;
//# sourceMappingURL=TrialBanner.js.map